// extracted by mini-css-extract-plugin
export default {"logoContainer":"Branding_logoContainer__cHsVC","logoImage":"Branding_logoImage__lQNOx"};